export default __webpack_public_path__ + "static/media/FfBG.6fe067e2.jpg";